export const themes = {
  default: {
    thRoot:
      'cursor-pointer flex gap-5 items-center font-bold font-sans leading-1 no-underline text-12',
    thIconWidth: '2.5rem',
    thTexts: 'flex flex-col',
    thSText: 'text-14 uppercase',
    thCustomText1: 'text-14 uppercase',
  },
  black: {
    thRoot:
      'flex gap-5 sm:gap-10 justify-end items-center font-bold font-sans leading-tight no-underline text-initial text-black text-16',
    thIconWidth: '2rem',
    thTexts: 'flex flex-col',
    thSText: '',
    thCustomText2: 'text-saffron',
  },
  footerLite: {
    thRoot: 'flex flex-col lg:flex-row gap_10 items-center text-center lg:text-initial text-black',
    thIconWidth: '1.5625rem',
    thTexts: 'lg:flex-1 text-black text-14',
    thSText: '',
    thCustomText0: 'font-bold text-16',
    thCustomText1: 'font-bold text-16',
  },
};
